import { MenuItem } from '@ui-lib/components';

export const HEADER_MENU_ITEMS_WEB: MenuItem[] = [
  {
    titleTranslateKey: 'header.menu.pool',
    url: '/',
    isExact: true,
    icon: 'widget',
  },
  {
    titleTranslateKey: 'header.menu.mining',
    url: '/mining',
    isAuthorizeOnly: true,
    icon: 'hammer',
  },
  {
    titleTranslateKey: 'header.menu.assets',
    url: '/finance',
    isAuthorizeOnly: true,
    icon: 'btc',
  },
  {
    titleTranslateKey: 'header.menu.reports',
    url: '/reports',
    isAuthorizeOnly: true,
    icon: 'clipboard-list',
  },
  {
    titleTranslateKey: 'header.menu.help',
    url: '/help',
    icon: 'question-circle',
  },
];

export const HEADER_MENU_ITEMS_NATIVE: MenuItem[] = [
  {
    titleTranslateKey: 'header.menu.pool',
    url: '/',
    isExact: true,
    icon: 'widget',
  },
  {
    titleTranslateKey: 'header.menu.mining',
    url: '/mining',
    isAuthorizeOnly: true,
    icon: 'hammer',
  },
  {
    titleTranslateKey: 'header.menu.assets',
    url: '/finance',
    isAuthorizeOnly: true,
    icon: 'btc',
  },
  {
    titleTranslateKey: 'header.menu.reports',
    url: '/reports',
    isAuthorizeOnly: true,
    icon: 'clipboard-list',
  },
  {
    titleTranslateKey: 'header.menu.help',
    url: '/help',
    icon: 'question-circle',
  },
];
